import { useCallback } from "react";

export const useGetFileFromSessionStorage = () => {
  const getFile = useCallback(async (key: string, fileName: string): Promise<File | null> => {
    const dataUrl = sessionStorage.getItem(key);
    if (!dataUrl) return null;

    try {
      const response = await fetch(dataUrl); // Faz um fetch da Data URL
      const blob = await response.blob(); // Converte a resposta em um Blob
      return new File([blob], fileName, { type: blob.type }); // Cria um File do Blob
    } catch (error) {
      console.error("Error converting data URL to File:", error);
      return null;
    }
  }, []);

  return getFile;
};
